import { Component, OnInit } from '@angular/core';
import { GlobalServices } from '../global.services';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {

  constructor(
    private globalService: GlobalServices
  ) { }

  ngOnInit(): void {
    if(this.globalService?.isBrowser){
      this.globalService?.hideHeader.next(false);
      this.globalService?.hideFooter.next(false);
    }
  }

}
